import { useQuery } from "react-query";
import { fetchData } from "../api/client";

/**
 * GET /client-tags/:id/analytics?start=&end=&date_field=
 */
export const useClientTagAnalytics = ({
  id,
  start,
  end,
  dateField,
  enabled = true,
} = {}) => {
  const tagId = Number(id);
  const hasId = Number.isFinite(tagId) && tagId > 0;
  const startStr = String(start || "").trim();
  const endStr = String(end || "").trim();
  const periodOk = Boolean(startStr && endStr && startStr <= endStr);
  const dateFieldStr = String(dateField || "").trim();

  return useQuery(
    ["client-tag-analytics", tagId, startStr, endStr, dateFieldStr],
    async () => {
      const qs = new URLSearchParams({
        start: startStr,
        end: endStr,
      });
      if (dateFieldStr) qs.set("date_field", dateFieldStr);
      return fetchData(`/client-tags/${tagId}/analytics?${qs.toString()}`);
    },
    {
      enabled: Boolean(enabled && hasId && periodOk),
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      keepPreviousData: true,
      select: (res) => {
        const raw = res?.data ?? res;
        if (!raw || typeof raw !== "object") {
          return {
            tag: null,
            period: { start: startStr, end: endStr },
            solicitacoes: { cards: {}, charts: {} },
            clientes: { cards: {}, charts: {} },
          };
        }
        return {
          tag: raw.tag || null,
          period: raw.period || { start: startStr, end: endStr },
          solicitacoes: {
            cards: raw.solicitacoes?.cards || {},
            charts: raw.solicitacoes?.charts || {},
          },
          clientes: {
            cards: raw.clientes?.cards || {},
            charts: raw.clientes?.charts || {},
          },
        };
      },
    }
  );
};

export default useClientTagAnalytics;
